<p-button
  (onClick)="open()"
  ariaLabel="Abrir menú de navegación"
  icon="pi pi-bars"
  [rounded]="true"
  severity="secondary"
  size="large"
  styleClass="fixed top-4 left-4 z-20 lg:hidden"
/>

@if (isOpen()) {
  <div class="fixed inset-0 z-10 bg-black/20 lg:hidden" (click)="close()"></div>
}

<aside
  class="bg-white z-30 fixed top-0 left-0 flex flex-col gap-4 *:mx-auto *:last:mt-auto rounded-xl border border-x-gray-100 w-56 lg:w-16 py-4 px-3 lg:px-0 m-2 h-[calc(100%-1rem)] -translate-x-[calc(100%+0.5rem)] transition-transform duration-300 lg:translate-x-0"
  [class.translate-x-0]="isOpen()"
>
  <ng-content></ng-content>
</aside>
